
(() => {
  const T = window.SA_TRACK;
  const BUS = window.SA_BUS;
  if (!T || !BUS || T.started) return;
  T.started = true;

  const DEBUG = (() => {
    try {
      if (/[?&]sa_debug=1\b/.test(location.search)) sessionStorage.setItem('sa_debug', '1');
      if (/[?&]sa_debug=0\b/.test(location.search)) sessionStorage.removeItem('sa_debug');
      return sessionStorage.getItem('sa_debug') === '1';
    } catch (e) { return false; }
  })();

  try {
    if (/[?&]sa_dry=1\b/.test(location.search)) sessionStorage.setItem('sa_dry', '1');
    if (/[?&]sa_dry=0\b/.test(location.search)) sessionStorage.removeItem('sa_dry');
    if (sessionStorage.getItem('sa_dry') === '1') T.dry = true;
  } catch (e) {  }
  T.log = [];
  const note = (entry) => {
    T.log.push({ at: Date.now(), ...entry });
    if (T.log.length > 200) T.log.shift();
    if (DEBUG) console.log('[SA_TRACK]', entry.to, entry.name, entry.params || '');
  };

  const MARKET = 'EU';
  const locale = () => String(document.documentElement.lang || T.locale || '').slice(0, 16);
  const uid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID()
    : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`);

  const st = { ready: false, ga: false, meta: false, gaLoaded: false, metaLoaded: false };
  T.state = st;
  const sentTo = new WeakMap();     
  const was = (ev, ch) => Boolean((sentTo.get(ev) || {})[ch]);
  const mark = (ev, ch) => sentTo.set(ev, { ...(sentTo.get(ev) || {}), [ch]: true });

  function gtagSend(name, params) {
    note({ to: 'ga4', name, params });
    if (T.dry) return;
    window.gtag('event', name, { ...params, send_to: T.ga4 });
  }
  function fbqSend(kind, name, params, eventID) {
    note({ to: 'meta', kind, name, params, eventID });
    if (T.dry || typeof window.fbq !== 'function') return;
    window.fbq(kind, name, params, eventID ? { eventID } : undefined);
  }

  const GA4_EVENTS = new Set([
    'view_item_list', 'view_item', 'select_item', 'search',
    'add_to_cart', 'remove_from_cart', 'view_cart', 'Use_promo_codes',
    'click_tel', 'click_phone_down', 'click_telegram',
    'instagram', 'facebook', 'tiktok', 'youtube',
    'click_banner', 'Click_cross_sell_cart', 'Click_cross_sell_product_card',
    'form_submit_partners', 'opt_en', 'popup_submit_discount',
    'Binotel GetCall - Call requested',
    'scroll_25%', 'scroll_50%', 'scroll_75%', 'scroll_100%',
  ]);
  const GA4_DROP = new Set(['source', 'lines']);   

  function toGa(ev) {
    if (!st.ga || !st.gaLoaded || !GA4_EVENTS.has(ev.name) || was(ev, 'ga')) return;
    mark(ev, 'ga');
    const params = {};
    Object.keys(ev.params || {}).forEach((k) => { if (!GA4_DROP.has(k)) params[k] = ev.params[k]; });
    params.transport_type = 'beacon';
    gtagSend(ev.name, params);
  }

  const base = () => ({ market: MARKET, locale: locale() });
  const round2 = (n) => Math.round(Number(n || 0) * 100) / 100;
  function content(p) {
    const items = Array.isArray(p.items) ? p.items : [];
    const out = {
      content_type: 'product',
      content_ids: items.map((i) => String(i.item_id)),
      contents: items.map((i) => ({ id: String(i.item_id), quantity: Number(i.quantity) || 1, item_price: round2(i.price) })),
      num_items: items.reduce((n, i) => n + (Number(i.quantity) || 1), 0),
      value: round2(p.value),
      currency: p.currency || T.currency,
      ...base(),
    };
    if (items.length === 1 && items[0].item_name) out.content_name = items[0].item_name;
    return out;
  }
  function metaFor(ev) {
    const p = ev.params || {};
    switch (ev.name) {
      // Native Facebook & Instagram owns Shopify commerce events.

      case 'click_tel': return [['track', 'Contact', { contact_method: 'phone', ...base() }, 'contact']];
      case 'click_telegram': return [['track', 'Contact', { contact_method: 'telegram', ...base() }, 'contact']];
      case 'whatsapp_click': return [['track', 'Contact', { contact_method: 'whatsapp', ...base() }, 'contact']];
      case 'opt_en': return [
        ['track', 'Lead', { lead_type: 'wholesale', ...base() }, 'lead_wholesale'],
        ['trackCustom', 'FormaOpt', base(), 'formaopt'],
      ];
      case 'Binotel GetCall - Call requested':
        return [['track', 'Lead', { lead_type: 'callback_request', ...base() }, 'lead_callback']];
      case 'popup_submit_discount': return [
        ['track', 'Subscribe', { subscription_type: 'discount', ...base() }, 'subscribe_discount'],
        ['trackCustom', 'popup_submit_discount', base(), 'popup_submit_discount'],
      ];
      case 'newsletter_subscribe':
        return [['track', 'Subscribe', { subscription_type: 'newsletter', ...base() }, 'subscribe_newsletter']];
      default: return [];
    }
  }
  function toMeta(ev) {
    if (!st.meta || was(ev, 'meta')) return;
    const list = metaFor(ev);
    if (!list.length) return;
    loadMeta();
    mark(ev, 'meta');
    list.forEach(([kind, name, params, prefix]) => fbqSend(kind, name, params, `${prefix}_${uid()}`));
  }

  function loadGa() {
    if (st.gaLoaded) return;
    st.gaLoaded = true;
    if (T.dry) { note({ to: 'ga4', name: 'config (dry — тег не вантажено)' }); return; }
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(T.ga4)}`;
    document.head.appendChild(s);
    window.gtag('js', new Date());

    window.gtag('config', T.ga4, DEBUG ? { debug_mode: true } : {});
    note({ to: 'ga4', name: 'config (page_view)', params: { id: T.ga4 } });
  }

  function loadMeta() {
    if (st.metaLoaded) return;
    st.metaLoaded = true;
    if (T.dry) { note({ to: 'meta', name: 'init (dry — тег не вантажено)' }); return; }

    const pixels = window.fbq?.getState?.()?.pixels || [];
    if (pixels.some((pixel) => String(pixel.id) === String(T.meta))) return;

    if (!window.fbq) {
      const n = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      window.fbq = n;
      if (!window._fbq) window._fbq = n;
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
      const s = document.createElement('script');
      s.async = true;
      s.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(s);
    }

    window.fbq('set', 'autoConfig', false, T.meta);
    const am = {};
    if (T.customer?.email) am.em = String(T.customer.email).trim().toLowerCase();
    if (T.customer?.id) am.external_id = String(T.customer.id);
    window.fbq('init', T.meta, am);
  }

  function replay(ch) {
    BUS.q.forEach((ev) => { if (ev.ctx) (ch === 'ga' ? toGa : toMeta)(ev); });
  }

  const privacy = () => window.Shopify && window.Shopify.customerPrivacy;
  function readConsent() {
    const cp = privacy();
    if (!cp) return { a: false, m: false };
    let a = false;
    let m = false;
    try { a = Boolean(cp.analyticsProcessingAllowed()); } catch (e) {  }
    try {
      m = Boolean(cp.marketingAllowed())
        && (typeof cp.saleOfDataAllowed !== 'function' || Boolean(cp.saleOfDataAllowed()));
    } catch (e) {  }
    return { a, m };
  }

  function applyConsent() {
    if (!privacy()) return;
    const { a, m } = readConsent();
    const hadGa = st.ga;
    const hadMeta = st.meta;
    st.ready = true;
    st.ga = a;
    st.meta = m;
    window.gtag('consent', 'update', {
      analytics_storage: a ? 'granted' : 'denied',
      ad_storage: m ? 'granted' : 'denied',
      ad_user_data: m ? 'granted' : 'denied',
      ad_personalization: m ? 'granted' : 'denied',
    });
    note({ to: 'consent', name: 'update', params: { analytics: a, marketing: m, region: safeRegion() } });

    if (a) { loadGa(); if (!hadGa) replay('ga'); }
    if (m) {
      if (typeof window.fbq === 'function') window.fbq('consent', 'grant');
      if (!hadMeta) replay('meta');
    } else if (typeof window.fbq === 'function') {
      window.fbq('consent', 'revoke');
    }
    syncCartConsent();
  }
  const safeRegion = () => { try { return privacy().getRegion(); } catch (e) { return ''; } };

  function whenPrivacy(cb) {
    if (privacy()) { cb(); return; }
    let done = false;
    const go = () => { if (!done && privacy()) { done = true; cb(); } };
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
        if (err) console.warn('[SA_TRACK] Customer Privacy API недоступний', err);
        go();
      });
    }
    let tries = 0;
    const t = setInterval(() => { tries += 1; go(); if (done || tries > 60) clearInterval(t); }, 250);
  }

  let cartCount = (T.cart?.items || []).reduce((n, l) => n + (Number(l.quantity) || 0), 0);
  let attrs = { ...(T.cart?.attributes || {}) };
  let syncing = false;
  let syncTimer = null;
  let fbpWaits = 0;
  const cookie = (name) => {
    const m = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : '';
  };
  function syncCartConsent(delay = 0) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(doSync, delay);
  }
  async function doSync() {
    if (!st.ready || !cartCount || syncing || T.dry) return;

    let vid = '';
    try { vid = localStorage.getItem('sa_vid') || ''; } catch (e) { vid = ''; }
    const want = st.meta
      ? { _sa_mkt: '1', _fbp: cookie('_fbp'), _fbc: cookie('_fbc'), _sa_vid: vid }
      : { _sa_mkt: '', _fbp: '', _fbc: '', _sa_vid: '' };

    if (st.meta && !want._fbp && fbpWaits < 10) { fbpWaits += 1; syncCartConsent(1500); return; }
    if (!Object.keys(want).some((k) => (attrs[k] || '') !== want[k])) return;
    syncing = true;
    try {
      const r = await fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: want }),
      });
      if (r.ok) {
        const cart = await r.json();
        attrs = { ...(cart.attributes || {}) };
        note({ to: 'cart', name: 'attributes', params: { _sa_mkt: attrs._sa_mkt || '' } });
      }
    } catch (e) {  } finally {
      syncing = false;
    }
  }

  BUS.on((ev) => {
    if (ev.name === 'cart_state') {
      cartCount = Number(ev.params.item_count || 0);
      attrs = { ...(ev.params.attributes || {}) };
      syncCartConsent(300);
      return;
    }
    toGa(ev);
    toMeta(ev);
  });

  document.addEventListener('visitorConsentCollected', applyConsent);
  whenPrivacy(applyConsent);
})();
